import React from "react";
import { PeekBox } from "@piiqtechnologies/ui-components";
export const NavigationLogo = () => {
    const handleLogoClick = () => {
        window.open("https://www.peek.us/", "_blank", "noreferrer");
    };
    return (React.createElement(PeekBox, { component: "img", sx: {
            width: "100px",
            height: "auto",
            cursor: "pointer",
        }, 
        // @ts-ignore
        src: "/images/peek_discover_dark_logo.svg", alt: "Peek Logo", onClick: handleLogoClick }));
};
export default NavigationLogo;
